import React from 'react';
import PropTypes from 'prop-types';
import Text from 'components/Text';
import { formatPrice } from 'helpers/Price';
import './ecoFeeModalContent.styles.scss';

const EcoFeeModalContent = ({ fee, regularPrice }) => (
    <div className="ecofeemodalcontent">
        <h2 className="ecofeemodalcontent__title"><Text textKey={'product_eco_participation_' + fee.type} /></h2>
        <p className="ecofeemodalcontent__text"><Text
            textKey={'product_eco_fee_information_' + fee.type}/></p>
        <div className="ecofeemodalcontent__price_breakdown">
            <p><span><Text textKey="product_eco_exluded"/></span><span>{formatPrice(regularPrice - fee.price)}</span></p>
            <p><span><Text textKey={'product_eco_participation_' + fee.type}/></span><span>{formatPrice(fee.price)}</span></p>
            <p><span><Text textKey="product_eco_total"/></span><span>{formatPrice(regularPrice)}</span></p>
        </div>
        {window.Checkout.settings.ecoParticipationUrl &&
        <a rel="noopener noreferrer" target="_blank" href={window.Checkout.settings.ecoParticipationUrl}>
            <Text textKey="product_eco_fee_readmore" />
        </a>}
    </div>
);

export default EcoFeeModalContent;

EcoFeeModalContent.propTypes = {
    fee: PropTypes.shape({
        price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        type: PropTypes.string.isRequired,
    }),
    regularPrice: PropTypes.number.isRequired,
};
